import styled from 'styled-components';

export const ExpandCollapseContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  background: #181818;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
`;
